import React from 'react';
import { Box, Checkbox, FormControlLabel, Grid, TextField, Typography } from '@mui/material';
import { Controller } from 'react-hook-form';
import type { AgentConfigurationCardProps } from '../../../../types/features/storeDetails/agentConfigurationCard';
import {
  adminCheckboxSx,
  adminFieldLabelSx,
  adminFormFieldSx,
  adminInlineControlLabelSx,
} from '../../../../styles/adminComponentStyles';

type AgentConfigurationGilbarcoPathsProps = Pick<AgentConfigurationCardProps, 'control'> & {
  readPathHasValue: boolean;
  writePathHasValue: boolean;
};

const AgentConfigurationGilbarcoPaths: React.FC<AgentConfigurationGilbarcoPathsProps> = ({
  control,
  readPathHasValue,
  writePathHasValue,
}) => {
  return (
    <>
      <Box
        sx={{
          backgroundColor: '#F8FBFF',
          border: '1px solid #2C6CA014',
          borderRadius: '8px',
          mb: 2,
          p: 1.5,
        }}
      >
        <Grid container spacing={1.5}>
      <Grid size={{ xs: 12 }}>
        <Box>
          <Typography sx={{ ...adminFieldLabelSx, mb: 0.5 }}>
            Root URL
          </Typography>
          <Controller
            name="NetworkShare.Root"
            control={control}
            render={({ field }) => (
              <TextField
                size="small"
                fullWidth
                placeholder="Enter root URL"
                value={field.value || ''}
                onChange={(e) => field.onChange(e.target.value)}
                sx={adminFormFieldSx}
                inputProps={{ 'aria-label': 'Root URL' }}
              />
            )}
          />
        </Box>
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <Box>
          <Typography sx={{ ...adminFieldLabelSx, mb: 0.5 }}>
            Username
          </Typography>
          <Controller
            name="NetworkShare.User"
            control={control}
            render={({ field }) => (
              <TextField
                size="small"
                fullWidth
                placeholder="Enter username"
                value={field.value || ''}
                onChange={(e) => field.onChange(e.target.value)}
                sx={adminFormFieldSx}
                inputProps={{ 'aria-label': 'Username' }}
              />
            )}
          />
        </Box>
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <Box>
          <Typography sx={{ ...adminFieldLabelSx, mb: 0.5 }}>
            Password
          </Typography>
          <Controller
            name="NetworkShare.Password"
            control={control}
            render={({ field }) => (
              <TextField
                size="small"
                fullWidth
                placeholder="Enter password"
                value={field.value || ''}
                onChange={(e) => field.onChange(e.target.value)}
                sx={adminFormFieldSx}
                inputProps={{ 'aria-label': 'Password' }}
              />
            )}
          />
        </Box>
      </Grid>
        </Grid>
      </Box>

      <Grid container spacing={2} sx={{ mb: 3 }}>
      <Grid size={{ xs: 12 }}>
        <Box>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
            <Typography sx={adminFieldLabelSx}>
              Read Path
            </Typography>
            <Controller
              name="PosDataUpload.Enabled"
              control={control}
              render={({ field }) => (
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={Boolean(field.value)}
                      disabled={!readPathHasValue}
                      onChange={(e) => field.onChange(e.target.checked)}
                      sx={adminCheckboxSx}
                    />
                  }
                  label="Is Enabled"
                  sx={adminInlineControlLabelSx}
                />
              )}
            />
          </Box>
          <Controller
            name="posConfig.ReadPath"
            control={control}
            render={({ field }) => (
              <TextField
                size="small"
                fullWidth
                placeholder="Enter read path"
                value={field.value || ''}
                onChange={(e) => field.onChange(e.target.value)}
                sx={adminFormFieldSx}
              />
            )}
          />
        </Box>
      </Grid>
      <Grid size={{ xs: 12 }}>
        <Box>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
            <Typography sx={adminFieldLabelSx}>
              Write Path
            </Typography>
            <Controller
              name="PosDataDownload.Enabled"
              control={control}
              render={({ field }) => (
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={Boolean(field.value)}
                      disabled={!writePathHasValue}
                      onChange={(e) => field.onChange(e.target.checked)}
                      sx={adminCheckboxSx}
                    />
                  }
                  label="Is Enabled"
                  sx={adminInlineControlLabelSx}
                />
              )}
            />
          </Box>
          <Controller
            name="posConfig.WritePath"
            control={control}
            render={({ field }) => (
              <TextField
                size="small"
                fullWidth
                placeholder="Enter write path"
                value={field.value || ''}
                onChange={(e) => field.onChange(e.target.value)}
                sx={adminFormFieldSx}
              />
            )}
          />
        </Box>
      </Grid>
      </Grid>
    </>
  );
};

export default React.memo(AgentConfigurationGilbarcoPaths);
